import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Select from 'react-select'
import { useAuthState } from "../../Helper/Context"
import { pathakNameDDLAPI } from "../../Redux/DDLSlice"

export const PathakNumberCodeDDL = (props) => {
    const { PathakNumberID, setPathakNumberID, ZoneNameID, Flag, data, IsPost, Language, StarMark, ApiFlag, ByDefaultShowFlag } = props
  
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    useEffect(() => {
        const data = {
            M_ZoneID: ZoneNameID.ID,
            UserID: UserID,
            Lanaguage: Language.Label ? Language.Label : Language,
            Flag: ApiFlag,
            token: token
        }

        dispatch(pathakNameDDLAPI({ data }))


    }, [IsPost, Language, ZoneNameID.ID])

    const { DDLData } = useSelector(state => state.pathakNameDDLData)

    useEffect(() => {
        handleDDL()
    }, [DDLData])

    const handleDDL = () => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_PathakID,
                label: item.pathakName,
            }))
            if (ByDefaultShowFlag == "ByDefaultShowFlag") {
                setPathakNumberID({
                    DDL: list,
                    ID: data?.m_PathakID,
                    Label: data?.pathakName,
                })
            } else {
                setPathakNumberID({
                    DDL: list,
                    ID: Flag == 'Update' ? data?.m_PathakID : 0,
                    Label: Flag == 'Update' ? data?.pathakName : "Select...",
                })
            }
        }
        else {
            setPathakNumberID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }
    return (
        <div className="form-group">
           <Select
                id='PathakNumberID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                isDisabled={ByDefaultShowFlag == "ByDefaultShowFlag" ? "disabled" : ''}
                maxMenuHeight={130}
                value={{ value: PathakNumberID?.ID, label: PathakNumberID?.Label }}
                onChange={(e) => {
                    e ?
                        setPathakNumberID({ ...PathakNumberID, ID: e.value, Label: e.label })
                        :
                        setPathakNumberID({ ...PathakNumberID, ID: 0, Label: "Select..." })

                }}
                options={PathakNumberID?.DDL}
            />
        </div>
    )
}